import ACTIVE_SCROLL from 'active-scroll';

new ACTIVE_SCROLL({
  nav: '.main-nav'
});
